var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeeStrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.934,
    height: 92.737,
    viewBox: "0 0 136.934 92.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 136.934,
    height: 92.737,
    transform: "translate(0 0)",
    fill: "#fef587"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(0 0.005)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    d: "M82.832,220.235a10.838,10.838,0,0,1-.155,4.633c-1.492,5.421-5.248,8.575-10.525,9.8-6.113,1.417-11.486-.092-15.641-5.018a10.99,10.99,0,0,1-2.615-8.209c.026-.343,0-.691,0-1.17-1.546.583-3.038,1.159-4.539,1.708-5.07,1.855-10.075,3.918-15.383,5.033a38.826,38.826,0,0,1-14.845.562,8.448,8.448,0,0,1-4.179-1.866,5.48,5.48,0,0,1-1.965-5.459c.153-.784-.022-1.062-.783-1.326a19.378,19.378,0,0,1-10.225-7.544,11.964,11.964,0,0,1-1.912-5.186,7.57,7.57,0,0,1,4.57-8.1,19,19,0,0,1,7.267-1.525c7.372-.261,14.425,1.338,21.333,3.728,7.063,2.443,13.962,5.308,20.853,8.191.8.334,1.205.32,1.756-.48,3.514-5.1,8.664-6.552,14.481-6.018,4.642.426,8.567,2.361,11.11,6.5.355.578.724.234,1.076.093,3.548-1.422,7.08-2.885,10.637-4.282,6.1-2.4,12.19-4.86,18.6-6.332A44.9,44.9,0,0,1,127.63,196.8a15.738,15.738,0,0,1,3.965,1.009c4.367,1.783,6.177,5.366,4.976,9.919-1.154,4.373-4.174,7.2-7.906,9.409a23.339,23.339,0,0,1-4.312,1.935c-.49.17-.626.337-.507.893a5.648,5.648,0,0,1-2.928,6.48,13.937,13.937,0,0,1-6.278,1.54,47.433,47.433,0,0,1-19.569-3.3c-4.042-1.5-8.1-2.944-12.237-4.443",
    transform: "translate(0.001 -179.682)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    d: "M990.171,556.825c-9.036-.616-16.288-4.461-21.563-11.92a1.445,1.445,0,0,1,.019-2.009,11.732,11.732,0,0,0,2.2-4.846c.08-.424.187-.671.755-.547,7.572,1.651,14.786,4.149,21.11,8.791a16,16,0,0,1,3.6,3.514c2.027,2.82,1.087,5.535-2.252,6.513a15.049,15.049,0,0,1-3.876.5",
    transform: "translate(-885.264 -491.426)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    d: "M296.975,556.524a13.626,13.626,0,0,1-4.069-.591c-3.045-1.038-3.921-3.543-2.142-6.224a17.36,17.36,0,0,1,5.142-4.754c6-3.95,12.686-6.194,19.626-7.792.435-.1.627,0,.732.451a14.953,14.953,0,0,0,2.638,5.451.687.687,0,0,1,.015.928c-5.242,7.828-12.615,11.9-21.942,12.532",
    transform: "translate(-265.019 -491.112)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M649.819,1.61c.219.809-.213,1.111-1.156,1.344a12.351,12.351,0,0,0-7.779,6.152c-.327.556-.122.791.349,1.054a10.639,10.639,0,0,1,3.224,2.665,8.35,8.35,0,0,1,1.446,8.219c-.214.658-.416.758-1.089.424-6.944-3.437-13.891-3.485-20.775.176-.728.387-.724-.058-.868-.479-1.34-3.908.07-7.878,3.689-10.384,1.756-1.216,1.763-1.221.42-2.986a12.169,12.169,0,0,0-7.423-4.979.615.615,0,0,1-.588-.594c-.346-2.207,0-2.54,2.1-1.869A15.726,15.726,0,0,1,630.6,8.022a1.21,1.21,0,0,0,1.553.734,13.071,13.071,0,0,1,5.022.076c.647.125.909-.064,1.2-.622A15.347,15.347,0,0,1,648.211.242c1.593-.446,1.6-.4,1.608,1.368",
    transform: "translate(-566.11 -0.005)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M632.728,654.169a22.327,22.327,0,0,1-13.861-5.015,1.859,1.859,0,0,1-.684-2.355,23.912,23.912,0,0,1,2.751-5.426c.34-.5.572-.509,1.061-.163a19.291,19.291,0,0,0,23.156-.038c.4-.282.59-.242.838.106a20.41,20.41,0,0,1,3.063,6.426c.16.576-.292.831-.608,1.123a21,21,0,0,1-9.415,4.679,26.6,26.6,0,0,1-6.3.663",
    transform: "translate(-565.07 -586.06)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M602.478,790.513c1.711.776,3.158,1.56,4.7,2.129a34.228,34.228,0,0,0,27.856-1.58c.3-.144.6-.546.929-.3.294.219.121.656.105,1-.024.526-.058,1.053-.129,1.574-.6,4.405-1.492,5.691-5.635,7.3-8.715,3.386-17.216,3.029-25.4-1.735a2.435,2.435,0,0,1-1.068-1.237,20.615,20.615,0,0,1-1.363-7.15",
    transform: "translate(-550.864 -722.79)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M649.773,942.277a30.263,30.263,0,0,0,25.314.152c.221.3-.02.448-.115.594a33.574,33.574,0,0,1-11.446,10.967,1.711,1.711,0,0,1-1.987-.037,34.853,34.853,0,0,1-11-10.41c-.211-.309-.39-.641-.768-1.267",
    transform: "translate(-594.107 -861.553)",
    fill: "#fef587"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeStrong);
export default __webpack_public_path__ + "static/media/bee-strong.4439f8f042521496a51260765c5682d0.svg";
export { ForwardRef as ReactComponent };